import { render, staticRenderFns } from "./categoryReport.vue?vue&type=template&id=4a513624&"
import script from "./categoryReport.vue?vue&type=script&lang=js&"
export * from "./categoryReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports